import axios from 'axios';
import { getToken } from '../context/AuthContextHelper';
import { refreshAccessToken } from './authService';



export const BACKEND_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8082"

const API = axios.create({
  // 2. Use the global URL + the /api suffix for your endpoints
  baseURL: `${BACKEND_URL}/api`, 
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true
});

// Helper to detect OS
const getClientOS = () => {
  const platform = window.navigator?.platform || '';
  const userAgent = window.navigator?.userAgent || '';

  if (platform.startsWith('Win')) return 'Windows';
  if (platform.startsWith('Mac')) return 'macOS';
  if (platform.startsWith('Linux')) return 'Linux';
  if (/Android/.test(userAgent)) return 'Android';
  if (/iPhone|iPad|iPod/.test(userAgent)) return 'iOS';

  return 'Unknown';
};

// Helper to detect Browser
const getClientBrowser = () => {
  const userAgent = window.navigator?.userAgent || '';
  if (userAgent.includes('Edg')) return 'Edge';
  if (userAgent.includes('Chrome')) return 'Chrome';
  if (userAgent.includes('Firefox')) return 'Firefox';
  if (userAgent.includes('Safari')) return 'Safari';
  return 'Unknown';
};

// Request interceptor → attach token
API.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
console.log("Base Url :", BACKEND_URL)
  // Add client hints for accurate logging
  config.headers['X-Client-OS'] = getClientOS();
  config.headers['X-Client-Browser'] = getClientBrowser();

  return config;
});

// Response interceptor → refresh token if expired
API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest.url.includes('/login')) {
      try {
        const newToken = await refreshAccessToken();
        error.config.headers['Authorization'] = `Bearer ${newToken}`;
        return API.request(error.config);
      } catch (refreshError) {
        localStorage.clear();
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default API;
